import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { User, EnvelopeSimple, CheckCircle } from '@phosphor-icons/react';
import { AuthShell, Field, SubmitBtn } from '../components/auth/AuthShell';

const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : '/api';

export default function WaitlistPage() {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [confirmed, setConfirmed] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setInfo('');
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/waitlist`, {
        full_name: fullName.trim(),
        email: email.trim().toLowerCase(),
      });
      const data = res.data;
      if (data.already_registered) {
        setError(data.message);
      } else if (data.already_on_list) {
        setInfo(data.message);
      } else {
        setConfirmed({ position: data.position, name: data.full_name });
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (confirmed) {
    return (
      <AuthShell subtitle="You're on the list">
        <div className="flex flex-col items-center gap-5 py-4">
          <div className="w-14 h-14 rounded-full bg-green-500/10 border border-green-500/20 flex items-center justify-center">
            <CheckCircle size={28} className="text-green-400" weight="fill" />
          </div>
          <div className="text-center">
            <p className="text-sm text-zinc-300 mb-4">
              Thanks, <span className="text-white font-medium">{confirmed.name.split(' ')[0]}</span>! Your spot is confirmed.
            </p>
            <div className="inline-block bg-[#0a0a0a] border border-amber-500/20 rounded-lg px-8 py-4 mb-4">
              <p className="text-[10px] uppercase tracking-wider text-zinc-500 mb-1">Your Position</p>
              <p className="text-3xl font-bold text-amber-500">#{confirmed.position}</p>
            </div>
            <p className="text-xs text-zinc-500 leading-relaxed">
              We'll email you an invite link when a spot opens up.<br />No action needed on your end.
            </p>
          </div>
          <div className="flex gap-4 pt-2">
            <Link to="/" className="text-xs text-zinc-500 hover:text-amber-400 transition-colors">
              Back to home
            </Link>
            <Link to="/auth" className="text-xs text-zinc-500 hover:text-amber-400 transition-colors">
              Already have an invite? Sign in
            </Link>
          </div>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell subtitle="Join the waitlist">
      <form onSubmit={handleSubmit} className="space-y-4">
        {error && (
          <div className="flex items-start gap-2 p-3 rounded-lg bg-red-500/10 border border-red-500/20">
            <p className="text-xs text-red-400">{error}</p>
          </div>
        )}
        {info && (
          <div className="flex items-start gap-2 p-3 rounded-lg bg-amber-500/10 border border-amber-500/20">
            <p className="text-xs text-amber-400">{info}</p>
          </div>
        )}

        <Field
          icon={User}
          label="Full Name"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
          placeholder="Jane Smith"
          autoFocus
        />
        <Field
          icon={EnvelopeSimple}
          label="Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="jane@example.com"
        />

        <div className="pt-1">
          <SubmitBtn loading={loading} label="Join Waitlist" />
        </div>
      </form>

      <div className="mt-5 text-center">
        <Link to="/auth" className="text-xs text-zinc-500 hover:text-amber-400 transition-colors">
          Already have an invite? Sign in →
        </Link>
      </div>
    </AuthShell>
  );
}
